const escapeHtml = value =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

export const toStaticGalleryItem = (source = {}) => {
  const src = String(source.src || '').trim()
  if (!src) return null
  const title = String(source.title || '').trim()
  const alt = String(source.alt || '').trim()
  const badges = source.isHDR ? '<span class="blog-lightbox-badge">HDR</span>' : ''
  return {
    src,
    thumb: src,
    alt: alt || undefined,
    subHtml: title || badges
      ? `<div class="blog-lightbox-caption">${title ? `<p>${escapeHtml(title)}</p>` : ''}${badges ? `<div>${badges}</div>` : ''}</div>`
      : undefined
  }
}
